<template>
    <q-card class="facility-card">
        <!-- Header -->
        <q-card-section class="bg-accent text-white q-my-xs">
            <div class="text-h6 text-center">{{ name }}</div>
            <div class="text-subtitle2 text-center">
                {{ city }}, {{ country }}
            </div>
        </q-card-section>
        <!-- <q-card-section class="q-mt-lg q-mb-lg text-center">
            <div v-if="eventsCount !== 0">
                <q-icon
                    name="fas fa-times-circle"
                    class="status__icon status__icon--negative"
                ></q-icon>
                <p class="q-mt-md">
                    {{ `${eventsCount} ${issuesFoundLabel}` }}
                </p>
            </div>
            <div v-else>
                <q-icon
                    name="fas fa-check-circle"
                    class="status__icon status__icon--positive"
                ></q-icon>
                <p class="q-mt-md">{{ $t('No issues found') }}</p>
            </div>
        </q-card-section> -->
    </q-card>
</template>

<script>
export default {
    name: 'FacilityCard',
    props: {
        name: {
            type: String,
            required: true
        },
        city: {
            type: String,
            required: true
        },
        country: {
            type: String,
            required: true
        },
        eventsCount: {
            type: Number,
            required: true
        }
    },
    computed: {
        /**
         * When issues are found, determine whether to display singular or plural form.
         * @returns {string} - Label to use when issues are found.
         */
        issuesFoundLabel() {
            let issuesFoundLabel = '';
            if (this.eventsCount === 1) {
                issuesFoundLabel = this.$t('downtime event');
            } else {
                issuesFoundLabel = this.$t('downtime events');
            }
            return issuesFoundLabel;
        }
    }
};
</script>

<style lang="scss" scoped>
.facility-card {
    cursor: pointer;
}

.status__icon {
    font-size: 60px;
}

.status__icon--negative {
    color: $negative;
}

.status__icon--positive {
    color: $positive;
}
</style>
